<template>
  <div>
    <div class="flex no-wrap column gap-2 mt-6">
      <widget-form-line :label="widgetData.nameLabel">
        <widget-form-field-text
          name="name"
          :placeholder="$t('subscribeWidgetForm.name')"
        />
      </widget-form-line>

      <widget-form-line :label="widgetData.phoneNumberLabel">
        <widget-form-field-phone
          country-name="countryCode"
          phone-name="phoneNumber"
          :available-countries="widgetData.allowedCountryIds"
        />
      </widget-form-line>
    </div>

    <widget-button
      class="w100pr mt-4"
      size="36"
      view="solid"
      :color="buttonColor"
      @click="$emit('submit')"
    >
      <span class="break-spaces break-word">
        {{ widgetData.submitText }}
      </span>
    </widget-button>
  </div>
</template>

<script lang="ts">
import WidgetFormLine from '@widgets/shared/components/WidgetFormLine.vue'
import WidgetFormFieldText from '@widgets/shared/components/fields/WidgetFormFieldText.vue'
import WidgetButton from '@widgets/shared/components/WidgetButton.vue'
import WidgetFormFieldPhone from '@widgets/shared/components/fields/WidgetFormFieldPhone.vue'
import type { WidgetButtonCustomColor } from '@widgets/shared/types'
import { type PropType, computed } from '@/composition/vue/compositionApi'
import { defineComponent } from '@/composition/vue/compositionApi'
import type { SubscribeWidgetData } from '@/services/domain/services/forms/subscribe/types'
import { styleVars } from '@/constants/styleVariables'

export default defineComponent({
  components: {
    WidgetFormFieldPhone,
    WidgetFormFieldText,
    WidgetButton,
    WidgetFormLine,
  },
  props: {
    widgetData: {
      type: Object as PropType<SubscribeWidgetData>,
      required: true,
    },
  },
  emits: {
    submit: () => true,
  },
  setup(props) {
    const buttonColor = computed<WidgetButtonCustomColor>(() => ({
      primary: props.widgetData.colorTheme === 'custom' ? props.widgetData.submitColor : styleVars.blue500,
      secondary: styleVars.white,
    }))

    return {
      buttonColor,
    }
  },
})
</script>
